/* eslint-disable indent */
/* eslint-disable camelcase */
/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import Icons from '@techsoftware/happay-widgets/FontIcon';
import Grid from '@techsoftware/happay-widgets/Grid';
import CookieLib from '../helpers/cookieLib';
import NavBar from './leftnavbar';
import GenericHeader from '../containers/GenericHeaderContainer';
import history from '../utils/history';
import Expenses from '../containers/expenseContainer';
import DashBoard from './dashboard/index';
import landingPage from '../reducers/landingpageReducers';
import Balance from '../containers/billContainer';
import HeaderAnimation from './header/headerAnimation';
import ProductSwitch from '@techsoftware/happay-widgets/ProductSwitch';
import ScrollToTopOnMount from './customComponent/scrolltoponmount';
import ProductGuide from '@techsoftware/happay-widgets/ProductGuide';

export default class LandingPage extends React.Component {
  constructor(props) {
    super(props);
    const bigScreen = window.screen.width > 1024;
    // const isDashboard = CookieLib.getCookieByKey('view_type') === 'dashboard';
    this.state = {
      isCollapsed: !bigScreen, //! bigScreen, // false,
      drawerOpen: false,
      openProductNavigation: false,
      count: 0,
      // showHelp: true,
    };
    this.onButtonClick = this.onButtonClick.bind(this);
    this.toggleCollapse = this.toggleCollapse.bind(this);
    this.handleSetViewGetOrgUserLimit = this.handleSetViewGetOrgUserLimit.bind(
      this,
    );
    // this.getOnboardConfig = this.getOnboardConfig.bind(this);
    // this.handleSetOnboardData = this.handleSetOnboardData.bind(this);
    // this.callKycForLink = this.callKycForLink.bind(this);
    // this.updateCount = this.updateCount.bind(this);
  }

  onButtonClick(ev, obj) {
    // console.log('gffff', ev);
    if (obj.key === 'add_user') {
      history.push('/people/addnewpeople');
    } else if (obj.key === 'add_card') {
      history.push('/card/assigncards');
    } else if (obj.key === 'plaid_button') {
      this.props.connectPlaid({
        plaid_public_key: ev,
      });
    } else if (obj.type === 'infoButton') {
      if (obj && obj.redirectLink) {
        window.open(obj.redirectLink, '_blank');
      }
      // this.setState({
      //   showHelp: true,
      // });
    } else if (obj.type === 'productSwitch') {
      this.setState({
        drawerOpen: !this.state.drawerOpen,
      });
    }
  }

  componentDidMount() {
    const {
      getInvoiceProduct,
      getTutorialFlag,
      productListAPICall,
    } = this.props;
    if (!productListAPICall) {
      const query = {
        pt_list: 0,
        product_status: 0,
      };
      getInvoiceProduct(query);
    }
    if (CookieLib.getCookieByKey('show_ipp_tutorial_flag') !== 'true') {
      getTutorialFlag();
    }
    // console.log(CookieLib.getCookieByKey('view_type'),'landingPage-did-mount')
  }

  componentDidUpdate(prevProps) {
    const {
      tutorialFlagResponse: { show_ipp_tutorial_flag = false } = {},
    } = this.props;
    if (
      show_ipp_tutorial_flag &&
      prevProps.tutorialFlagResponse.show_ipp_tutorial_flag !==
        show_ipp_tutorial_flag
    ) {
      setTimeout(() => {
        this.setState({
          openProductNavigation: true,
        });
      }, 500);
    }
  }

  handleSetViewGetOrgUserLimit() {
    this.props.getWalletLimit();
    // if (Object.keys(this.props.onboard).length === 0) {
    //   this.props.checkDasboardView(CookieLib.getCookieByKey('org_id'));
    // }
  }

  // handleSetOnboardData() {
  //   this.props.checkDasboardView(CookieLib.getCookieByKey('org_id'));
  // }

  getUserName() {
    const { userInfo = {} } = this.props;
    let name = '';
    if (userInfo.first_name && userInfo.last_name) {
      name = `${userInfo.first_name[0]}${userInfo.last_name[0]}`;
    }
    return name;
  }

  getHeaderConfig() {
    const { userInfo = {}, location, productList } = this.props;
    const obj = {};
    let inforedirectLink = 'http://help.happay.in/en/';
    if (location?.pathname === '/people') {
      obj.button = {
        name: '+ Add users',
        type: 'button',
        id: 4,
        key: 'add_user',
      };
      inforedirectLink =
        'http://help.happay.in/en/collections/2199059-how-to-add-a-new-user-on-happay-epic';
    } else if (location?.pathname.includes('card')) {
      if (location.pathname.includes('assignedbyme')) {
        obj.button = {
          name: 'Assign Cards',
          type: 'button',
          id: 14,
          key: 'add_card',
        };
      } else if (location.pathname.includes('usedbyme')) {
        obj.button = {
          name: 'Assign Card',
          type: 'button',
          id: 15,
          key: 'add_card',
        };
      }
      inforedirectLink =
        'http://help.happay.in/en/collections/2199078-understanding-cards-on-the-happay-epic-platform';
    }
    if (location.pathname === '/bankaccounts') {
      obj.plaidButton = {
        type: 'plaidButton',
        id: 5,
        key: 'plaid_button',
      };
    }
    obj.limitInfo = {
      name: '',
      id: 11,
      type: 'limitInfo',
      key: 'limitInfo',
    };
    obj.infoButton = {
      name: '',
      id: 9,
      type: 'infoButton',
      redirectLink: inforedirectLink,
    };
    if (productList?.length) {
      obj.productSwitch = {
        name: '',
        type: 'productSwitch',
        id: 7,
      };
    }
    obj.userButton = {
      name: this.getUserName(),
      type: 'userButton',
      id: 3,
      fullName: `${userInfo.first_name} ${userInfo.last_name}`,
    };
    return obj;
  }

  toggleCollapse() {
    const { isCollapsed } = this.state;
    this.setState({
      isCollapsed: !isCollapsed,
    });
  }

  returnEl = (text, description) => (
    <Grid container>
      <Grid container justify="space-between">
        <div className="font-16 body dark fw-500 margin-b-10">{text}</div>
        <Icons
          tabIndex={1}
          interactive
          onClick={() => {
            CookieLib.setCookieByKey('show_ipp_tutorial_flag', false);
            this.setState({ openProductNavigation: false, count: 0 });
          }}
          size="small"
          type="cross"
          id="product-nav-cross"
        />
      </Grid>
      <div className="font-14 body margin-b-32">{description}</div>
    </Grid>
  );

  returnIds = () => [
    {
      id: '#dashboard-buttons-1',
      element: this.returnEl(
        'Register Vendor',
        'Get started by registering a new vendor.',
      ),
      style: { left: -150 },
      pointerStyle: { left: 226 },
    },
    {
      id: '#dashboard-buttons-0',
      style: { left: -100 },
      element: this.returnEl(
        'Create Invoice',
        'Create invoices for the registered vendors.',
      ),
      pointerStyle: { left: 184 },
    },
    {
      id: '#limitInfo',
      element: this.returnEl(
        'Credit Balance',
        'Available credit balance for spending on Happay credit products.',
      ),
      pointerStyle: { left: 174 },
      style: { left: -100 },
    },
    {
      id: '#product-switch-icon',
      element: this.returnEl(
        'Product Switch',
        'You can go here to switch to other Happay products.',
      ),
      pointerStyle: { left: 266 },
      style: { left: -250 },
    },
  ];

  // callKycForLink() {
  //   this.props.getkycPortalLink();
  // }

  // drawProductList() {
  //   let uiData = [];
  //   uiData = this.props.productList.map((item, i) => {
  //     const name = item.display_name.split(' ');
  //     return (
  //       <Grid
  //         item
  //         xs={5}
  //         md={3}
  //         lg={3}
  //         className="overlay-card"
  //         onClick={ev => {
  //           CookieLib.setCookieByKey('product', item.id);
  //           if (item.redirection_url.includes('https')) {
  //             window.open(`${item.redirection_url}`, '_blank');
  //           } else {
  //             window.open(`https://${item.redirection_url}`, '_blank');
  //           }
  //           ev.preventDefault();
  //           ev.stopPropagation();
  //         }}
  //       >
  //         <div
  //           className="card-logo"
  //           style={{
  //             display: 'inline-block',
  //             background: `url(${invoiceLogo}) 0% 0% / contain no-repeat`,
  //           }}
  //         ></div>
  //         <div style={{ display: 'inline-block', position: 'absolute' }}>
  //           <div className="cmp-name"> {name[0]} </div>
  //           <div className="product-name"> {name[1]} </div>
  //         </div>
  //         <div className="product-desc">{item.description}</div>
  //       </Grid>
  //     );
  //   });
  //   if (this.props.productList.length < 3) {
  //     const ite = 3 - this.props.productList.length;
  //     for (let i = 0; i < ite; i++) {
  //       uiData.push(
  //         <Grid item xs={5} md={3} lg={3} className="overlay-card "></Grid>,
  //       );
  //     }
  //   }
  //   return uiData;
  // }

  getOnboardConfig() {
    this.props.checkDasboardView(CookieLib.getCookieByKey('org_id'));
  }

  // updateCount(type) {
  //   if (type !== 'stateUpdate') {
  //     const { onboard } = this.props;
  //     const { meta_data } = onboard;
  //     const obj = { dashboardCount: 1 };
  //     const finaObj = { ...meta_data, ...obj };
  //     this.props.updateOnboardMetaData(finaObj);
  //   }
  // }

  render() {
    // const { region } = Locale;
    // const isDashboard = CookieLib.getCookieByKey('view_type') === 'dashboard';
    const { drawerOpen, openProductNavigation, count } = this.state;
    const { productList = [], userInfo = {} } = this.props;
    return (
      <Grid container alignItems="flex-start" xs={24}>
        <ScrollToTopOnMount />
        {(openProductNavigation ||
          CookieLib.getCookieByKey('show_ipp_tutorial_flag') === 'true') &&
          userInfo && (
            <ProductGuide
              ids={this.returnIds()}
              id="product-navigation"
              onClose={() => {
                CookieLib.setCookieByKey('show_ipp_tutorial_flag', false);
                this.setState({ openProductNavigation: false, count: 0 });
              }}
              overlayStyle={{ width: '350px' }}
              overlayWrapperStyle={{ borderRadius: '4px' }}
              button={[
                {
                  buttonParentStyles: { padding: '10px 16px' },
                  hide: count < 1,
                  onClick: (prevElement, currentElement, count) =>
                    this.setState({
                      count: count - 1,
                    }),
                },
                {
                  buttonParentStyles: { padding: '10px 16px' },
                  text:
                    this.returnIds().length - 1 === count
                      ? 'Okay, got it'
                      : 'Next',
                  variant: 'secondary',
                  onClick: (prevElement, currentElement, count) =>
                    this.setState({
                      count: count + 1,
                    }),
                },
              ]}
            />
          )}
        <Grid
          item
          xs={24}
          className={this.state.isCollapsed ? 'hp-navbar-mini' : 'hp-navbar'}
        >
          <NavBar
            isCollapsed={this.state.isCollapsed}
            changeCollapse={this.toggleCollapse}
            userInfo={this.props && this.props.userInfo}
          />
        </Grid>
        <Grid
          className={this.state.isCollapsed ? 'hp-content-mini' : 'hp-content'}
        >
          <GenericHeader
            headerconfig={this.getHeaderConfig()}
            onButtonClick={this.onButtonClick}
          />
          <Grid
            container
            item
            xs={24}
            className="app-section padding-l-50 padding-r-50 padding-b-30"
            alignItems="baseline"
          >
            <Switch>
              <Route exact path="/dashboard">
                <DashBoard
                  userInfo={this.props.userInfo || {}}
                  org_limit={this.props.org_limit}
                  user_limit={this.props.user_limit}
                  // isAdminView={this.props.isAdminView}
                  // set_view_get_limit={this.handleSetViewGetOrgUserLimit}
                  // onboard={this.props.onboard}
                  // setOnboardData={this.handleSetOnboardData}
                  // callKyc={this.callKycForLink}
                  // updateCount={this.updateCount.bind(this)}
                />
              </Route>
              <Route path="/balance" component={Balance} />
              <Route
                path="/vendor/:assignType/:vendorType"
                component={() => {
                  <div>test</div>;
                }}
              />
              <Route path="/invoice/:assignType" component={Expenses} />
              <Route path="/vendor/:assignType" component={Expenses} />
            </Switch>
          </Grid>
        </Grid>
        <HeaderAnimation />
        <ProductSwitch
          open={drawerOpen}
          onCrossClick={() => this.setState({ drawerOpen: false })}
          currentProduct="IPP"
          productDetails={productList}
        />
      </Grid>
    );
  }
}

LandingPage.propTypes = {
  userInfo: PropTypes.object,
  location: PropTypes.object,
  getWalletLimit: PropTypes.func,
  connectPlaid: PropTypes.func,
  user_limit: PropTypes.object,
  org_limit: PropTypes.object,
  getInvoiceProduct: PropTypes.func,
  productList: PropTypes.array,
  checkDasboardView: PropTypes.func,
};

landingPage.defaultProps = {
  userInfo: {},
  location: {},
  org_limit: {},
  user_limit: {},
  productList: [],
  onboard: {},
};
